import { NavLink } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { visibleNavItems } from "@/auth/permissions";
import "@/styles/layout.css";

type Props = {
  mobileOpen?: boolean;
  onNavigate?: () => void;
};

export function Sidebar({ mobileOpen = false, onNavigate }: Props) {
  const { user } = useAuth();
  const items = visibleNavItems(user);

  return (
    <aside className={`sidebar${mobileOpen ? " open" : ""}`}>
      <div className="brand">
        <div className="brand-mark" aria-hidden>
          <svg width="20" height="20" viewBox="0 0 32 32" fill="none">
            <path d="M8 22V12l8-5 8 5v10" stroke="#5eead4" strokeWidth="2" />
          </svg>
        </div>
        <div>
          <h1>Andrew Insurance</h1>
          <p>Agency + Claims OS</p>
        </div>
      </div>
      <nav className="nav-list">
        {items.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === "/"}
            className={({ isActive }) => `nav-link${isActive ? " active" : ""}`}
            onClick={onNavigate}
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
      <div className="sidebar-footer">
        <div>{user?.display_name}</div>
        <div style={{ color: "#94a3b8", fontSize: "0.75rem" }}>{user?.role}</div>
      </div>
    </aside>
  );
}
